import { render } from "./componentEditReader.vue?vue&type=template&id=245bf586&scoped=true"
import script from "./componentEditReader.vue?vue&type=script&lang=js"
export * from "./componentEditReader.vue?vue&type=script&lang=js"

import "./componentEditReader.vue?vue&type=style&index=0&id=245bf586&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245bf586"]])

export default __exports__